module.exports = "/packs/images/products/pod-packs@3x-71009db533cec39038cd35763c7aec64.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/pod-packs@3x.png
// module id = 969
// module chunks = 0 1